import WhoWeAreImg from "../../../assets/who-we-are.webp";
import SlideX from "../../atoms/slide-x"
import GoldDots from "../../../assets/golddots.webp"
import Rectangle from "../../../assets/rect.webp"

const WhoWeAre = () => {
  return (
    <div className="who-we-are">
      <img className="rect" src={Rectangle} alt="Rectangle" />
      <div className="inner">
        <img src={WhoWeAreImg} alt="Who We Are " />
        <div className="inner-contents">
          <div className="title-desc">
            <h4>Who We Are</h4>
            <p>
              We're not just a tech company; we're your strategic partner on the
              journey to digital transformation and business success. We
              specialize in crafting innovative software solutions that empower
              organizations to thrive in the digital age. Explore our world, and
              together, we'll elevate your business to new heights.
            </p>
          </div>
          <div className="details">
            <div className="content">
              <h6>Founded</h6>
              <SlideX>
                <h3>2016</h3>
              </SlideX>
            </div>

            <div className="content small">
              <h6>Based In</h6>
              <SlideX>
                <h3>Chicago, USA</h3>
              </SlideX>
            </div>

            <div className="content">
              <h6>Outreach</h6>
              <SlideX>
                <h3>Global</h3>
              </SlideX>
            </div>

            <div className="content">
              <h6>Employees</h6>
              <SlideX>
                <h3>160+</h3>
              </SlideX>
            </div>
          </div>
        </div>
      </div>
      <img className="gold" src={GoldDots} alt="Gold Dots" />
    </div>
  );
};

export default WhoWeAre;
